<template>
    <div>
        <base-modal
            @modalClose="close"
            :show-modal="showModal"
            :modal-size="modalSize"
        >
            <template v-slot:content>
                <div class="cz3__info-modal__text">
                    <div v-if="text" v-html="text"></div>
                    <slot v-else name="content"></slot>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<style>
    #cz3 .cz3__info-modal__text h3 {
        @apply mb-4 font-semibold font-oceanside;
    }

    #cz3 .cz3__info-modal__text a {
        @apply text-blue underline;
    }

    #cz3 .cz3__info-modal__link-text-red a {
        @apply text-red underline;
    }
</style>

<script>
    import BaseModal from './BaseModal.vue';

    export default {
        components: {
            BaseModal,
        },

        props: {
            button: String,
            text: {
                type: String,
            },
            modalSize: {
                type: String,
                default: 'small',
            },
        },

        data() {
            return {
                showModal: true,
            };
        },

        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>
